@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/transitions.scss' as *;

.NavGroup {
  @extend %font-family-primary;

  // <button/> resets
  text-align: left;
  font-size: 11px;
  border: none;
  cursor: pointer;

  &,
  &:active {
    background: none;
  }

  // The overly complex dance of the width and max-width has to do with the transiton.
  // Without these tweaks, the parent of this element (Sidebar) will snap instead of transitioning.

  display: grid;
  grid-template-columns: auto 1fr 20px; // icon, label, icon with room for larger hover size
  align-items: center;
  justify-items: start;
  color: $color-white;
  height: 55px;
  line-height: 55px;
  box-sizing: border-box;
  max-width: 175px;
  width: 100%;
  padding: 0 28px;
  transition: all $transition-duration ease-in-out;
  white-space: nowrap;
  outline: none;

  .Label {
    transition: all $transition-duration ease-in-out;
    vertical-align: middle;
    display: inline-block;
    padding-left: 1em;
    // Needs a defined value to transition
    max-width: 75px;
    text-decoration: inherit;
  }

  svg {
    vertical-align: middle;
    height: 22.5px;
    width: 22.5px;

    path {
      fill: currentColor;
    }
  }

  svg.Caret {
    height: 14px;
    width: 14px;
  }

  &:hover,
  &:focus {
    svg.Caret {
      height: 20px;
      width: 20px;
    }
  }

  &.isCollapsed {
    grid-template-columns: auto 0 0; // icon, label, icon with room for larger hover size

    .Label,
    svg.Caret {
      opacity: 0;
      max-width: 0;
      width: auto;
      padding: 0;
    }
  }

  &[aria-current] {
    background: $color-primary-purple;
  }
}
